import styled, { css } from 'styled-components';
import ProgressBar from 'react-bootstrap/ProgressBar';

import { Card, FormSelectField } from '_components/_core';

export const CustomCard = styled(Card)`
  border: 1px solid #F1F1F4;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  padding-bottom: 0;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
`;

export const CustomCardHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #F1F1F4;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    font-size: 16px;
    margin-bottom: 0;
    color: #071437;
  }

  ${({ isClickable }) =>
    isClickable &&
    css`
    cursor: pointer;

    :hover {
      background-color: #F9F9FB;
    }
  `}
`;

export const CustomCardBody = styled.div`
  padding: 16px;

  ${({ noPadding }) =>
    noPadding &&
    css`
    padding: 0;
  `}

`;

export const CustomCardFooter = styled.div`
  padding: 8px 16px;
  border-top: 1px solid #F1F1F4;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled.div`
  font-weight: 600;
  color: #99A1B7;
  font-size: 13px;

  span.dark {
    color: #252F4A;
  }
`;

export const Value = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #252F4A;
  width: fit-content;

  ${({ variant }) =>
    variant === 'large' &&
    css`
    font-size: 22px;

    small {
      font-size: 14px;
    }
  `}
  
  ${({ variant }) =>
    variant === 'medium' &&
    css`
    font-size: 18px;

    small {
      font-size: 10px;
    }
  `}

  ${({ variant }) =>
    variant === 'light' &&
    css`
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    color: #78829D;
  `}
`;

export const Footer = styled.div`
  color: #393A3D;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    padding: 0;
    margin: 0;
  }

`;

export const StyledFormSelectField = styled(FormSelectField)`
  &&& {
    width: 200px;

    ${props => props.width && `width: ${props.width};`}
  }
`;

export const SummaryTable = styled.table`
  thead tr th {
    color: #4B5675;
    font-weight: 600;
    font-size: 12.5px;
    text-transform: uppercase;
    padding: 4px 0px;   
  }

  tbody tr td {
    border-bottom: 1px solid #DBDFE9;   
    color: #4B5675;
    font-weight: 400;
    font-size: 14px;
    padding: 13px 0px;
  }

  tbody tr.active td {
    background: #eceef1;
  }

  tfoot tr td {
    color: #4B5675;
    font-weight: 600;
    font-size: 12.5px;
    text-transform: uppercase;   
    padding-top: 8px;
    border-top: 1px solid #DBDFE9;
  }
`;

export const StyledProgressBar = styled(ProgressBar)`
  height: 14px;

  & .progress {
  }

  #expense-1 {
    background-color: #FCEDB9;
    border-radius: 0;
  }

  #expense-2 {
    background-color: #FCBD3A;
    border-radius: 0;
  }

  #expense-3 {
    background-color: #FF8F0E;
    border-radius: 0;
  }

  #income-1 {
    background-color: #D7F7C2;
    border-radius: 0;
  }

  #income-2 {
    background-color: #76DF47;
    border-radius: 0;
  }

  #income-3 {
    background-color: #48C404;
    border-radius: 0;
  }

  #warning {
    background-color: rgb(0, 161, 194);
    border-radius: 0;
  }

  #danger {
    background-color: rgb(237, 104, 4);
    border-radius: 0;
  }

  #success {
    background-color: rgb(153, 102, 255);
    border-radius: 0;
    
  }

  ${({ isLast }) =>
    !isLast &&
    css`
    border-right: 1px solid #fff;  
  `}

  ${({ isLast }) =>
    isLast &&
    css`
    border-right: none !important;
  `}
`;

export const Circle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: ${({ color }) => color};
`;
